<div class="flex justify-between gap-2 items-center">
  <div class="flex-1">
    <select class="w-full p-2 border rounded" [(ngModel)]="filter" (change)="onFilterChange()">
      <option value="tutte">Tutte</option>
      <option value="sistema">Sistema</option>
      <option value="events">Eventi</option>
    </select>
  </div>
  <div class="text-right">
    <p-button
      icon="pi pi-calendar-plus"
      styleClass="p-button-text"
      pTooltip="Crea attività futura"
      tooltipPosition="top"
      (onClick)="onScheduleEvent()"
    >
    </p-button>
  </div>
</div>

<div *ngIf="filteredItems.length === 0" class="text-center text-gray-500 p-4">Nessun evento da mostrare</div>

<div class="flex gap-2 bg-black bg-opacity-5 p-2 my-2 rounded-lg" *ngFor="let item of filteredItems">
  <div class="w-1/12 p-2 flex items-center justify-center">
    <div>
      <div class="text-xl font-extrabold">{{ item.createdAt | date : 'dd' }}</div>
      <div class="font-bold text-gray-500">{{ item.createdAt | date : 'MMMM' : '' : 'it-IT' }}</div>
      <div class="font-light text-gray-500">{{ item.createdAt | date : 'YYYY' }}</div>
      <div class="font-light text-gray-500">{{ item.createdAt | date : 'HH:mm' }}</div>
    </div>
  </div>
  <!-- <div class="flex items-center justify-center w-8 h-8 rounded-full">
    <i class="fas {{ item.icon }}"></i>
  </div> -->
  <div class="flex-1">
    <ng-container *ngIf="item.type === 'project_sale_lead'">
      <p-card>
        <div>{{ item.title }}</div>
        <div>
          <h5 class="font-bold" *ngIf="item.description?.length; else descriptionString">
            <div *ngFor="let descrItem of item.description">
              <small>{{ descrItem.label }}: {{ descrItem.value }}</small>
            </div>
          </h5>
          <ng-template #descriptionString>
            <h5 class="font-bold">
              {{ item.description | domainValue : 'lead_state' | async }}
            </h5>
          </ng-template>
        </div>
        <div>
          <h6 class="text-sm"><strong>Operatore:</strong><br />{{ item.operator }}</h6>
        </div>
      </p-card>
    </ng-container>

    <ng-container *ngIf="item.type === 'project_sale_opportunity'">
      <p-card>
        <div>{{ item.title }}</div>
        <div>
          <h5 class="font-bold">
            {{ item.description | domainValue : 'opportunity_state' | async }}
          </h5>
        </div>
        <div>
          <h6 class="text-sm"><strong>Operatore:</strong><br />{{ item.operator }}</h6>
        </div>
      </p-card>
    </ng-container>
    <ng-container *ngIf="item.type === 'project_purchase_opportunity'">
      <p-card>
        <div>{{ item.title }}</div>
        <div>
          <h5 class="font-bold">
            {{ item.description | domainValue : 'opportunity_purchase_state' | async }}
          </h5>
        </div>
        <div>
          <h6 class="text-sm"><strong>Operatore:</strong><br />{{ item.operator }}</h6>
        </div>
      </p-card>
    </ng-container>

    <ng-container *ngIf="item.type === 'event'">
      <p-card [ngClass]="item.extras.isExpired ? 'bg-red-100' : 'bg-yellow-100'">
        <div class="flex justify-between">
          <div>{{ getEventLabel(item.description) }} il {{ item.title }}</div>
          <div>
            <p-button
              *ngIf="item.extras.eventType !== 16"
              icon="pi pi-check-circle"
              styleClass="p-button-text p-button-rounded"
              pTooltip="Esita evento"
              tooltipPosition="top"
              (onClick)="onResultEvent(item.extras.eventId)"
            >
            </p-button>
          </div>
        </div>
        <div>
          <h5 class="font-bold">Cliente: {{ item.user }}</h5>
          <p class="mt-2">Agente: {{ item.agent }}</p>
          <p *ngIf="item.extras.eventState" class="mt-2">Esito: {{ getEventState(item.extras.eventState) }}</p>
          <p *ngIf="item.extras?.eventNotes" class="mt-2">Note: {{ item.extras?.eventNotes }}</p>
        </div>
        <div>
          <h6 class="text-sm"><strong>Operatore:</strong><br />{{ item.operator }}</h6>
        </div>
      </p-card>
    </ng-container>

    <ng-container *ngIf="item.type === 'property'">
      <p-card>
        <div>{{ item.title }}</div>
        <div>
          <ng-container *ngFor="let atttribute of item.description">
            <p class="mt-2">
              {{ atttribute.label }}:
              {{ atttribute.domain ? (atttribute.value | domainValue : atttribute.domain | async) : atttribute.value }}
            </p>
          </ng-container>
        </div>
        <div>
          <h6 class="text-sm"><strong>Operatore:</strong><br />{{ item.operator }}</h6>
        </div>
      </p-card>
    </ng-container>

    <ng-container *ngIf="item.type === 'properties_update'">
      <p-card>
        <div>{{ item.title }}</div>
        <div>
          {{ item.description }}
        </div>
        <div>
          <h6 class="text-sm"><strong>Operatore:</strong><br />{{ item.operator }}</h6>
        </div>
      </p-card>
    </ng-container>
    <ng-container *ngIf="item.type === 'documents'">
      <p-card>
        <div>
          {{ item.title }}
        </div>
        <div>
          <ng-container *ngFor="let atttribute of item.description">
            <p class="mt-2">
              {{ atttribute.label }}:
              {{ atttribute.domain ? (atttribute.value | domainValue : atttribute.domain | async) : atttribute.value }}
            </p>
          </ng-container>
        </div>
        <div>
          <h6 class="text-sm"><strong>Operatore:</strong><br />{{ item.operator }}</h6>
        </div>
      </p-card>
    </ng-container>

    <ng-container *ngIf="item.type === 'privacy'">
      <p-card>
        <div>{{ item.title }}</div>
        <div>
          <h5 class="font-bold" *ngIf="item.description?.length">
            <div *ngFor="let descrItem of item.description">
              <small>{{ descrItem.label }}: {{ descrItem.value }}</small>
            </div>
          </h5>
        </div>
        <div>
          <h6 class="text-sm"><strong>Operatore:</strong><br />{{ item.operator }}</h6>
        </div>
      </p-card>
    </ng-container>

    <ng-container *ngIf="item.type === 'proposals'">
      <p-card>
        <div>
          {{ item.title }}
        </div>
        <div>
          <ng-container *ngFor="let atttribute of item.description">
            <p class="mt-2">
              {{ atttribute.label }}:
              {{ atttribute.domain ? (atttribute.value | domainValue : atttribute.domain | async) : atttribute.value }}
            </p>
          </ng-container>
        </div>
        <div>
          <h6 class="text-sm"><strong>Operatore:</strong><br />{{ item.operator }}</h6>
        </div>
      </p-card>
    </ng-container>
  </div>
</div>
